exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".monitor-item[data-v-215647e8]{position:relative}.monitor-item .loader[data-v-215647e8]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.75)}", ""]);

// exports
